// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries
import { getAuth } from "firebase/auth";
// import { getMessaging, getToken } from "firebase/messaging";
import { getFirestore } from "firebase/firestore";

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAayXF-Xi7h2wboE2hjGPkkNQh0mU5TxE8",
  authDomain: "loot-d73f4.firebaseapp.com",
  projectId: "loot-d73f4",
  storageBucket: "loot-d73f4.firebasestorage.app",
  messagingSenderId: "115879674113",
  appId: "1:115879674113:web:8edeb190cedc7774c19b00",
  measurementId: "G-J71J51HESS",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

// Initialize Firebase Authentication and get a reference to the service
const auth = getAuth(app);
// auth.languageCode = "it";
// To apply the default browser preference instead of explicitly setting it.
auth.useDeviceLanguage();

// Initialize Firebase Cloud Messaging and get a reference to the service
// const messaging = getMessaging(app);

// Initialize Cloud Firestore and get a reference to the service
const db = getFirestore(app);

export { db };
